export const encodeBase64 = (input: any): string => {
  const base64String = btoa(input);

  const urlEncodedString = encodeURIComponent(base64String);

  return urlEncodedString;
};
